import type { ClientError } from '@tribeplatform/gql-client/lib'
import {
  MutationUpdateModerationItemArgs,
  Action,
  ModerationStatus,
} from '@tribeplatform/gql-client/types'

import {
  useMutation,
  UseMutationOptions,
} from '../../lib/react-query/useMutation.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import {
  getModerationItemsKey,
  getPostModerationItemsKey,
} from '../../utils/keys/moderation.key.js'
import { removeFromModerationItems } from '../cache/useCachedModerationItem.js'

export const useUpdateModerationItem = (options?: {
  useMutationOptions?: UseMutationOptions<
    Action,
    ClientError,
    MutationUpdateModerationItemArgs
  >
}) => {
  const { useMutationOptions } = options || {}
  const { client } = useTribeClient()
  const queryClient = useQueryClient()
  const moderationItemsKey = getModerationItemsKey()
  const postModerationItemsKey = getPostModerationItemsKey()
  return useMutation<Action, ClientError, MutationUpdateModerationItemArgs>(
    variables => client.moderation.updateItem(variables),
    {
      onMutate: variables => {
        queryClient.cancelQueries(moderationItemsKey)
        queryClient.cancelQueries(postModerationItemsKey)

        if (
          variables?.input?.status === ModerationStatus.REJECTED ||
          variables?.input?.status === ModerationStatus.ACCEPTED
        ) {
          removeFromModerationItems(variables.id, queryClient)
        }
      },
      onSettled: () => {
        // invalidate to refetch again
        queryClient.invalidateQueries(moderationItemsKey)
        queryClient.invalidateQueries(postModerationItemsKey)
      },
      ...useMutationOptions,
    },
  )
}
